import { render, staticRenderFns } from "./FutureStageFooter.vue?vue&type=template&id=bf199d28&"
import script from "./FutureStageFooter.vue?vue&type=script&lang=js&"
export * from "./FutureStageFooter.vue?vue&type=script&lang=js&"
import style0 from "./FutureStageFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports